import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Spinner from 'components/Core/Spinner/Spinner';
import { assortmentActions, modalActions } from 'actions';
import Moment from 'moment';
import { ButtonPrimary } from 'components/Core/Button/Button';
import Icon from 'components/Icon/Icon';
import DatePicker from 'react-datepicker';
import withStyle from './ModalBulkAddSelection.style';

const ModalBulkAddSelection = ({ className, selectedClients, uploadSelectionBulk, closeModal }) => {
  const [file, setFile] = useState(null);
  const [label, setLabel] = useState('');
  const [date, setDate] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [results, setResults] = useState(null);
  const [showFullErrors, setShowFullErrors] = useState(false);
  const clientCount = (selectedClients || []).length;
  const canSubmit = file && label && date && clientCount > 0 && !isSubmitting;
  const ERROR_GROUPS_PREVIEW_COUNT = 2;
  const ERROR_CLIENTS_PREVIEW_COUNT = 20;
  const errorGroups = (results && results.errorGroups) || [];
  const hasManyErrorGroups = errorGroups.length > ERROR_GROUPS_PREVIEW_COUNT;
  const hasLargeClientList = errorGroups.some(
    (group) => (group.clients || []).length > ERROR_CLIENTS_PREVIEW_COUNT
  );
  const canExpandErrors = hasManyErrorGroups || hasLargeClientList;
  const visibleErrorGroups =
    showFullErrors || !canExpandErrors
      ? errorGroups
      : errorGroups.slice(0, ERROR_GROUPS_PREVIEW_COUNT);

  const selectFile = (e) => {
    setFile(e.target.files[0] || null);
  };

  const deleteFile = () => {
    setFile(null);
  };

  const handleSubmit = () => {
    if (!file || !label || !date || !selectedClients || selectedClients.length === 0) {
      return null;
    }
    const dateEndLocale = Moment(date).isValid() ? Moment(date).format('YYYY-MM-DD') : null;
    setIsSubmitting(true);
    setShowFullErrors(false);
    uploadSelectionBulk(
      {
        label,
        file,
        dateEnd: dateEndLocale,
        selectedClients,
      },
      (uploadResults) => {
        setIsSubmitting(false);
        setResults(uploadResults);
      }
    );
    return true;
  };

  const handleClose = () => {
    if (closeModal) closeModal();
  };

  return (
    <div className={className}>
      {clientCount > 0 && (
        <div className="bulk-modal__summary">
          <span className="bold">{clientCount} client(s) sélectionné(s) : </span>
          {(selectedClients || [])
            .slice(0, 5)
            .map((c) => c.ext_code || c.name || c.id)
            .join(', ')}
          {clientCount > 5 && ` … et ${clientCount - 5} autre(s)`}
        </div>
      )}
      <div className="bulk-modal__field">
        <label htmlFor="bulkLabel">Libellé de la sélection</label>
        <input
          id="bulkLabel"
          type="text"
          placeholder="LIBELLÉ DE LA SÉLECTION"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          maxLength="30"
        />
      </div>
      <div className="bulk-modal__field">
        <label htmlFor="bulkDate">Date de fin de validité</label>
        <DatePicker
          id="bulkDate"
          selected={date && Moment(date).isValid() ? Moment(date).toDate() : null}
          onChange={(day) => setDate(day ? Moment(day).format('YYYY-MM-DD') : '')}
          dateFormat="dd/MM/yyyy"
          placeholderText="DATE DE FIN DE VALIDITÉ"
          locale="fr"
        />
      </div>
      <div className="file">
        <label htmlFor="bulkFileInput" className="btn__file">
          <span>Parcourir</span>
          <input
            type="file"
            id="bulkFileInput"
            className="input-file"
            onChange={selectFile}
            accept=".xls,.xlsx"
            hidden
          />
        </label>
      </div>
      <div className="oldFile" hidden={!file}>
        <span className="bold">{file && file.name}</span>
        <Icon onClick={deleteFile} content="\e915" />
      </div>
      {!file && (
        <div className="page-profil__alert-bloc">
          <span className="alert-bloc__label">Aucun document n&apos;a été importé</span>
        </div>
      )}
      {results ? (
        <div className="bulk-modal__results">
          <p className="bold">Résultat de l&apos;import</p>
          <p>
            Réussis : {results.successCount} / {results.total}
          </p>
          {results.failedCount > 0 && (
            <div>
              <p className="error">Échecs : {results.failedCount} client(s)</p>
              {results.errorGroups && results.errorGroups.length > 0 ? (
                <div className="error">
                  {visibleErrorGroups.map((group, index) => {
                    const clients = group.clients || [];
                    const visibleClients =
                      showFullErrors || !canExpandErrors
                        ? clients
                        : clients.slice(0, ERROR_CLIENTS_PREVIEW_COUNT);
                    const remainingClientsCount = clients.length - visibleClients.length;
                    return (
                      <p key={`bulk-error-group-${index}`}>
                        {group.message} (
                        {visibleClients.map((client) => client.ext_code || client.id).join(', ')}
                        {remainingClientsCount > 0 ? ` ... +${remainingClientsCount}` : ''})
                      </p>
                    );
                  })}
                  {canExpandErrors && (
                    <button
                      type="button"
                      onClick={() => setShowFullErrors((prev) => !prev)}
                      style={{
                        border: 'none',
                        background: 'transparent',
                        color: '#003b7a',
                        cursor: 'pointer',
                        padding: 0,
                        marginBottom: 12,
                        fontWeight: 700,
                      }}
                    >
                      {showFullErrors
                        ? 'Masquer le détail complet'
                        : 'Afficher les erreurs complètes'}
                    </button>
                  )}
                </div>
              ) : (
                results.failures &&
                results.failures.length > 0 && (
                  <p className="error">
                    {(results.failures || []).map((f) => f.ext_code || f.id).join(', ')}
                  </p>
                )
              )}
            </div>
          )}
          <ButtonPrimary onClick={handleClose}>
            <span>Fermer</span>
          </ButtonPrimary>
        </div>
      ) : (
        <div className="validate">
          {isSubmitting ? (
            <Spinner />
          ) : (
            <ButtonPrimary onClick={handleSubmit} disabled={!canSubmit}>
              <span>Valider</span>
            </ButtonPrimary>
          )}
        </div>
      )}
    </div>
  );
};

ModalBulkAddSelection.propTypes = {
  className: PropTypes.string,
  uploadSelectionBulk: PropTypes.func,
  selectedClients: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      ext_code: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  closeModal: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
  uploadSelectionBulk: (payload, onComplete) =>
    dispatch(assortmentActions.uploadSelectionBulk(payload, onComplete)),
  closeModal: () => dispatch(modalActions.close()),
});

export default connect(null, mapDispatchToProps)(withStyle(ModalBulkAddSelection));
